import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { formatCurrency, formatDate, capitalize } from '../../../../utils/FormatUtil';

const ItemRow = props => {
  const { dap } = props;

  return (
    <Container fluid>
      <Row>
        <Col
          md={2}
          sm={12}
          xs={12}
          className="dap_listado-borde-izquierda dap_listado-espacio-abajo"
        >
          <b>Número</b>
          <p>{dap.id}</p>
        </Col>
        <Col
          md={2}
          sm={3}
          xs={6}
          className="dap_listado-destacado dap_listado-espacio-abajo"
        >
          <b>Ganancia</b>
          <p>{formatCurrency(dap.ganancia)}</p>
        </Col>
        <Col md={2} sm={3} xs={6} className="dap_listado-espacio-abajo">
          <b>Monto invertido</b>
          <p>{formatCurrency(dap.montoInvertir)}</p>
        </Col>
        <Col md={2} sm={3} xs={6} className="dap_listado-espacio-abajo">
          <b>Fecha de Vencimiento</b>
          <p>{formatDate(dap.fechaVencimiento)}</p>
        </Col>
        <Col
          md={2}
          sm={3}
          xs={6}
          className="dap_listado-borde-izquierda dap_listado-espacio-abajo"
        >
          <b>Tipo</b>
          <p>{capitalize((dap.tipo || '').toLowerCase())}</p>
        </Col>

        <Col md={2} sm={6} xs={6} className="dap_listado-link-posicion">
          <Link
            to={{ pathname: '/detalle', id: dap.id }}
            className="dap_listado-link"
          >
            Ver detalle
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default ItemRow;
